import { render, staticRenderFns } from "./FormLaboratory.vue?vue&type=template&id=2939c847&scoped=true"
import script from "./FormLaboratory.vue?vue&type=script&lang=js"
export * from "./FormLaboratory.vue?vue&type=script&lang=js"
import style0 from "./FormLaboratory.vue?vue&type=style&index=0&id=2939c847&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2939c847",
  null
  
)

export default component.exports